import { Component, Input, OnInit } from '@angular/core';
import { MenuManagementService } from 'src/app/menu/services/menu-management.service';
import { CoverageQuantitativeAssessmentService } from 'src/app/services/coverage-quantitative-assessment.service';
import { ToolsControlService } from 'src/app/services/tools-control.service';
import * as fileSaver from 'file-saver';
import { TabsService } from 'src/app/services/tabsService';

@Component({
  selector: 'app-coverage-quantitative-assessment-result',
  templateUrl: './coverage-quantitative-assessment-result.component.html',
  styleUrls: ['./coverage-quantitative-assessment-result.component.scss'],
  standalone: false
})


export class CoverageQuantitativeAssessmentResultComponent implements OnInit {

  constructor(
    public cqaController : CoverageQuantitativeAssessmentService,
    public toolsService : ToolsControlService,
    public menuController : MenuManagementService,
    public tabsService: TabsService) {}

  ngOnInit(): void {
  }

  exportToCsv() {
    var fileName = "ExportedCovQuantAssess_" + new Date().toISOString().slice(0, 19) + ".csv";
    var rows = this.cqaController.results;
    if (!rows || !rows.length) {
      return;
    }
    const separator = ';';
    const keys = ["ID",
    "No coverage",
    "No Redundacy",
    "Limited Redundacy",
    "Full Redundacy",
    "High Redundacy",
    "Total Coverage"];
    const csvContent =
      keys.join(separator) + separator +
      '\n' +
      rows.map(row => {
        return row.type + separator + row.values.map(k => {
          let cell = k === null || k === undefined ? '' : k;
          return cell + "%";
        }).join(separator) + separator;
      }).join('\n');


    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    fileSaver.saveAs(blob, fileName);
  }


}






